import glamorous from "glamorous"
import style from "utils/style"

const Paragraph = glamorous.p({
  fontSize: "1.05rem",
  fontWeight: 200,
  letterSpacing: 0.01,
  lineHeight: 1.4,
  color: style.colors.altBrown,
  marginBottom: 10,
})

export default Paragraph



// WEBPACK FOOTER //
// ./src/elements/Paragraph.js